// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__D5mpH","loading-wheel":"styles_loading-wheel__kDpS3"};